import type { ComponentPropsWithoutRef, ElementType } from 'react';

type Props<T extends ElementType> = { as?: T } & ComponentPropsWithoutRef<T>;

/** Screen-reader-only content (§1.2 "no information carried by colour, sound, motion or haptics alone"). */
export function VisuallyHidden<T extends ElementType = 'span'>({ as, className, ...rest }: Props<T>) {
  const Tag = (as ?? 'span') as ElementType;
  return <Tag className={['wd-sr-only', className].filter(Boolean).join(' ')} {...rest} />;
}
